import React from 'react';
import { Alert, Button, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import type { OrderDocumentCompleteness } from '../../../types/orderDocumentCompleteness';
import './OrderDocumentCompletenessSection.css';
import { completenessStateColor, completenessSummary } from '../orderDocumentCompletenessPresentation';

/** One presentation for ZK/ZD. The server owns expected documents and coverage. */
export default function OrderDocumentCompletenessSection({ value, visible, status, onPlanTransport, transportActionLabel }: { value?: OrderDocumentCompleteness; visible: boolean; status?: string; onPlanTransport?: () => void; transportActionLabel?: string }) {
  const { t } = useTranslation('orders');
  if (!visible || !value) return null;
  const pending = value.checks.filter(check => check.state !== 'COMPLETE');
  const missing = pending.some(check => check.state !== 'UNKNOWN');
  return <div className="order-document-completeness" data-testid="order-document-completeness">
    <Alert showIcon type={missing ? 'warning' : pending.length || !value.checks.length ? 'info' : 'success'}
      message={t(`orders:documentCompleteness.${completenessSummary(value, status)}`)}
      description={pending.length ? <>
        <ul>{pending.map(check => <li key={check.code}>
          <span>{t(`orders:documentCompleteness.codes.${check.code}`)}</span>
          <Tag color={completenessStateColor[check.state]}>{t(`orders:documentCompleteness.states.${check.code === 'TRANSPORT_INVOICE' && check.state === 'PARTIAL' ? 'PARTIAL_TRANSPORT_INVOICE' : check.state}`)}</Tag>
          {check.code === 'TRANSPORT' && ['MISSING', 'PARTIAL'].includes(check.state) && onPlanTransport && <Button type="link" size="small" onClick={onPlanTransport}>{transportActionLabel || t('orders:process.ready.planTransport')}</Button>}
          {check.missingCount !== undefined && <span>{t('orders:documentCompleteness.trucks', { count: check.missingCount, total: check.totalCount })}</span>}
        </li>)}</ul>
        <span>{t('orders:documentCompleteness.hint')}</span>
      </> : undefined} />
  </div>;
}
